// event start banner resources
import EventStartBanner3MoCenterBg from "@/assets/images/banner3/event-start/mo_c.png"
import EventStartBanner3MoLeftBg from "@/assets/images/banner3/event-start/mo_l.png"
import EventStartBanner3MoRightBg from "@/assets/images/banner3/event-start/mo_r.png"
import EventStartBanner3PcCenterBg from "@/assets/images/banner3/event-start/pc_c.png"
import EventStartBanner3PcLeftBg from "@/assets/images/banner3/event-start/pc_l.png"
import EventStartBanner3PcRightBg from "@/assets/images/banner3/event-start/pc_r.png"

// event end banner resources
import EventEndBanner3MoCenterBg from "@/assets/images/banner3/event-end/mo_c.png"
import EventEndBanner3MoLeftBg from "@/assets/images/banner3/event-end/mo_l.png"
import EventEndBanner3MoRightBg from "@/assets/images/banner3/event-end/mo_r.png"
import EventEndBanner3PcCenterBg from "@/assets/images/banner3/event-end/pc_c.png"
import EventEndBanner3PcLeftBg from "@/assets/images/banner3/event-end/pc_l.png"
import EventEndBanner3PcRightBg from "@/assets/images/banner3/event-end/pc_r.png"

import { device_px, secondary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_1919, MAX_1439, MAX_1279, MAX_767 } = device_px

export const Banner3Container = styled.div`
  margin-top: 78px;

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: 66px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 64px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin-top: 87px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 60px;
  }
`

export const Banner3Wrapper = styled.div`
  position: relative;
  height: 977px;
  background: center / contain repeat-x url(${EventStartBanner3PcCenterBg});

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    height: 100%;
    aspect-ratio: 850 / 1100;
  }

  &::before {
    left: 0;
    background: center / cover no-repeat url(${EventStartBanner3PcLeftBg}) black;
  }

  &::after {
    right: 0;
    background: center / cover no-repeat url(${EventStartBanner3PcRightBg})
      black;
  }

  &.event-end {
    background: center / contain repeat-x url(${EventEndBanner3PcCenterBg});

    &::before {
      background: center / cover no-repeat url(${EventEndBanner3PcLeftBg}) black;
    }

    &::after {
      background: center / cover no-repeat url(${EventEndBanner3PcRightBg})
        black;
    }
  }

  @media only screen and (max-width: ${MAX_1919}) {
    height: 716px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    height: 629px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    height: 368px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    height: 304px;
    background: center / contain repeat-x url(${EventStartBanner3MoCenterBg});

    &::before,
    &::after {
      aspect-ratio: 290 / 652;
    }

    &::before {
      background: center / contain no-repeat url(${EventStartBanner3MoLeftBg})
        black;
    }

    &::after {
      background: center / contain no-repeat url(${EventStartBanner3MoRightBg})
        black;
    }

    &.event-end {
      background: center / contain repeat-x url(${EventEndBanner3MoCenterBg});

      &::before {
        background: center / cover no-repeat url(${EventEndBanner3MoLeftBg})
          black;
      }

      &::after {
        background: center / cover no-repeat url(${EventEndBanner3MoRightBg})
          black;
      }
    }
  }
`

export const Banner3Content = styled.div`
  position: absolute;
  top: 122px;
  left: 50%;
  z-index: 3;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;

  &.event-end {
    top: 123px;
  }

  @media only screen and (max-width: ${MAX_1919}) {
    top: 75px;

    &.event-end {
      top: 51px;
    }
  }

  @media only screen and (max-width: ${MAX_1439}) {
    top: 80px;

    &.event-end {
      top: 67px;
    }
  }

  @media only screen and (max-width: ${MAX_1279}) {
    top: -3px;

    &.event-end {
      top: -3px;
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    width: 100%;
    top: -9px;

    &.event-end {
      &.ko {
        top: -8px;
      }

      &.en {
        top: -21px;
      }
    }
  }
`

export const Title = styled.h3`
  font-size: 50px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -1.5px;

  @media only screen and (max-width: ${MAX_1919}) {
    font-size: 38px;
    letter-spacing: -1.14px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    font-size: 26px;
    letter-spacing: -0.78px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    font-size: 24px;
    letter-spacing: -0.72px;
  }
`

export const Description = styled.div`
  margin-top: 40px;
  max-width: 100%;
  white-space: pre-wrap;
  font-size: 28px;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: -0.84px;

  br.desktop {
    display: inline;
  }

  br.mobile {
    display: none;
  }

  span {
    font-weight: 700;
    color: ${secondary.text};
  }

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: 30px;
    font-size: 20px;
    letter-spacing: -0.6px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: -0.54px;
  }

  @media only screen and (max-width: ${MAX_1279}) {
    font-size: 14px;
    font-weight: 500;
    line-height: 165%;
    letter-spacing: -0.42px;
  }

  @media only screen and (max-width: ${MAX_767}) {
    max-width: 220px;

    br.desktop {
      display: none;
    }

    br.mobile {
      display: inline;
    }

    &.en {
      max-width: 180px;
    }

    &.en.event-end {
      max-width: 100%;
    }

    &.ko.event-end {
      max-width: 100%;
    }
  }
`

export const Note = styled.div`
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.4);

  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: -0.54px;

  &::before {
    display: inline-block;
    content: "";
    margin: 0 7px 4px 0;

    border-radius: 50%;
    width: 4px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.4);
  }

  span {
    color: rgba(255, 255, 255, 0.8);
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 10px;
    font-size: 12px;
    line-height: 165%; /* 19.8px */
    letter-spacing: -0.36px;

    &::before {
      margin: 0 7px 2px 0;
      width: 3px;
      height: 3px;
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 20px;
    max-width: 170px;
    font-size: 10px;
    line-height: 160%; /* 16px */
    letter-spacing: -0.3px;

    &.event-end {
      max-width: 100%;
    }
  }
`

export const WatchLiveBtn = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 80px;
  border: none;
  border-radius: 94px;
  padding: 29px 131px 29px 57px;

  color: ${secondary.text};
  background-color: black;
  box-shadow:
    0px 7px 16.3px 0px rgba(255, 225, 0, 0.25) inset,
    0px -14px 20px 0px rgba(0, 151, 215, 0.1) inset;

  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.84px;
  white-space: pre-line;

  cursor: pointer;
  user-select: none;

  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    inset: -1px;
    border-radius: 96px;
    background-image: linear-gradient(to top, #9bc454, #f2df0c);
  }

  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 40px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${secondary.text};
  }

  .live-icon {
    position: absolute;
    top: 0;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 94px;
    height: 94px;
    border-radius: 94px;

    &::before {
      content: "";
      position: absolute;
      inset: -1px;
      border-radius: 96px;
      background-image: linear-gradient(to top, #9bc454, #f2df0c);
    }

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 94px;
      background-color: black;
    }

    svg {
      position: relative;
      z-index: 2;
    }
  }

  @media only screen and (max-width: ${MAX_1919}) {
    margin-top: 47px;
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 40px;
    border-radius: 82px;
    padding: 26px 100px 26px 50px;

    box-shadow:
      0px 6.125px 14.262px 0px rgba(255, 225, 0, 0.25) inset,
      0px -12.25px 17.5px 0px rgba(0, 151, 215, 0.1) inset;

    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.72px;

    &::before {
      border-radius: 84px;
    }

    &::after {
      top: 21px;
      left: 35px;
    }

    .live-icon {
      width: 82px;
      height: 82px;
      border-radius: 82px;

      &::before {
        border-radius: 84px;
      }

      &::after {
        border-radius: 82px;
      }

      svg {
        width: 20px;
        height: auto;
      }
    }
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin-top: 32px;
    border-radius: 54px;
    padding: 17px 66px 14px 33px;

    box-shadow:
      0px 4.083px 9.508px 0px rgba(255, 225, 0, 0.25) inset,
      0px -8.167px 11.667px 0px rgba(0, 151, 215, 0.1) inset;

    font-size: 16px;
    line-height: 23px;
    letter-spacing: -0.48px;

    &::before {
      border-radius: 56px;
    }

    &::after {
      top: 14px;
      left: 24px;
      width: 3px;
      height: 3px;
    }

    .live-icon {
      width: 54px;
      height: 54px;
      border-radius: 54px;

      &::before {
        border-radius: 56px;
      }

      &::after {
        border-radius: 54px;
      }

      svg {
        width: 13px;
      }
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 20px;
    border-radius: 46px;
    padding: 14px 61px 11px 25px;

    box-shadow:
      0px -2px 5px 0px rgba(0, 151, 215, 0.1) inset,
      0px 2px 4px 0px rgba(255, 225, 0, 0.5) inset;

    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.42px;

    &::before {
      border-radius: 48px;
    }

    &::after {
      top: 12px;
      left: 18px;
    }

    .live-icon {
      width: 46px;
      height: 46px;
      border-radius: 46px;

      &::before {
        border-radius: 48px;
      }

      &::after {
        border-radius: 46px;
      }

      svg {
        width: 13px;
      }
    }
  }
`

export const RecordedLiveStreamBtn = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  border: none;
  border-radius: 103px;
  padding: 29px 29px;
  min-width: 527px;

  color: #ffe100;
  background-color: black;
  box-shadow:
    0px -14px 20px 8px rgba(0, 151, 215, 0.1) inset,
    0px 7px 16px 8px rgba(255, 225, 0, 0.25) inset;

  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.84px;
  white-space: pre-line;
  cursor: default;

  span {
    color: ${secondary.text};
  }

  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    inset: -1px;
    border-radius: 105px;
    background-image: linear-gradient(to top, #9bc454, #f2df0c);
  }

  @media only screen and (max-width: ${MAX_1919}) {
    border-radius: 80px;
    padding: 22px 29px;
    box-shadow:
      0px -14px 17px 0px rgba(0, 151, 215, 0.1) inset,
      0px 8px 15px -4px rgba(255, 225, 0, 0.44) inset;

    &::before {
      border-radius: 82px;
    }
  }

  @media only screen and (max-width: ${MAX_1439}) {
    margin-top: 60px;
    border-radius: 71px;
    padding: 21px 29px;
    min-width: 460px;
    box-shadow:
      0px -10px 12px 0px rgba(0, 151, 215, 0.1) inset,
      0px 8px 14px -6px rgba(255, 225, 0, 0.44) inset;

    font-size: 24px;
    line-height: 29px;
    letter-spacing: -0.72px;

    &::before {
      border-radius: 73px;
    }
  }

  @media only screen and (max-width: ${MAX_1279}) {
    margin-top: 32px;
    border-radius: 57px;
    padding: 18px 23px;
    min-width: 282px;
    box-shadow:
      0px -4px 5px -3px rgba(0, 151, 215, 0.1) inset,
      0px 3px 6px -2px rgba(255, 225, 0, 0.44) inset;

    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.42px;

    &::before {
      border-radius: 59px;
    }
  }

  @media only screen and (max-width: ${MAX_767}) {
    margin-top: 20px;
    border-radius: 46px;
    padding: 12px 21px;
    min-width: 206px;
    box-shadow:
      0px -2px 5px 0px rgba(0, 151, 215, 0.1) inset,
      0px 2px 4px 0px rgba(255, 225, 0, 0.5) inset;

    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.42px;

    &::before {
      border-radius: 48px;
    }

    &.en {
      display: block;
      border-radius: 72px;
      padding: 14px 21px;
      min-width: 184px;
      width: 184px;

      &::before {
        border-radius: 74px;
      }
    }
  }
`
